import Vue from 'vue';
import App from './App.vue';
import core from '@bmp-vue/core';
import tools from '@/plugins/util/tools';
import DatePicker from '../src/components/Datepicker.vue';

Vue.config.productionTip = false;

var controllers = require.context('@/controllers', true, /\.js$/);
const paths = require('@/plugins/router/paths').default;
const theme = require('@/plugins/vuetify/theme').default;

import { datadogRum } from '@datadog/browser-rum';

const FALLBACK_VERSION = '0.1.0';

const resolveAppVersion = async () => {
  try {
    const response = await fetch(`${process.env.BASE_URL}version.json`, { cache: 'no-store' });

    if (!response.ok) {
      return FALLBACK_VERSION;
    }

    const data = await response.json();
    const version = data && data.version ? String(data.version).trim() : '';

    if (!version || version.toUpperCase().includes('CONFIGURADO')) {
      return FALLBACK_VERSION;
    }

    return version;
  } catch (error) {
    console.warn('Nao foi possivel carregar version.json. Usando versao padrao no Datadog RUM.', error);
    return FALLBACK_VERSION;
  }
};

const buildAllowedTracingUrls = () => {
  const apiBaseUrls = [
    process.env.VUE_APP_ROOT_API,
    process.env.VUE_APP_PERSON_API
  ];

  const origins = new Set();

  apiBaseUrls.forEach((baseUrl) => {
    if (!baseUrl) return;

    try {
      origins.add(new URL(baseUrl).origin);
    } catch (error) {
      console.warn(`URL de API ignorada no tracing do Datadog (invalida): ${baseUrl}`, error);
    }
  });

  return Array.from(origins).map((origin) => ({
    match: origin,
    propagatorTypes: ['datadog']
  }));
};

const initDatadogRum = (version) => {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DATADOG_APP_CLIENT,
    clientToken: process.env.VUE_APP_DATADOG_APP_TOKEN,
    site: 'datadoghq.com',

    service: 'partner-web',
    env: process.env.NODE_ENV || 'development',
    version,

    sessionSampleRate: 100,
    sessionReplaySampleRate: 5,

    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,

    allowedTracingUrls: buildAllowedTracingUrls(),
    traceSampleRate: 100,

    defaultPrivacyLevel: 'mask-user-input'
  });

  Vue.config.errorHandler = (err, vm, info) => {
    datadogRum.addError(err, {
      component: vm?.$options?.name,
      info
    });

    console.error(err);
  };
};

const extendRouterBeforeEach = (vm) => {
  var empresa = vm.$store.getters.empresa;
  return empresa && empresa.codigo;
};

const clearNotification = () => {
  var html = document.querySelector('.vue-notification-group');
  html.innerHTML = '';
  html.appendChild(document.createElement('span'));
};

const bootstrap = () => {
  Vue.use(tools);

  Vue.use(core, {
    controllers,
    paths,
    theme,
    defaultViews: false,
    carregaEnums: false,
    extendRouterBeforeEach,
    mount: (options) => {
      Vue.component('DatePicker', DatePicker);

      Vue.prototype.$clearNotification = clearNotification;

      if (options.router) {
        options.router.afterEach((to) => {
          datadogRum.setViewName(
            to.name || to.path
          );
        });
      }

      new Vue({
        ...options,
        render: h => h(App)
      }).$mount('#app');
    }
  });
};

resolveAppVersion().then((version) => {
  initDatadogRum(version);
  bootstrap();
});

Vue.directive('uppercase', {
  bind(el, _, vnode) {
    el.addEventListener('input', e => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase());
    });
  }
});

Vue.directive('disable-all', {
  bind: function(el, binding) {
    if (!binding.value) return;

    const tags = ['input', 'button', 'textarea', 'select'];
    tags.forEach(tagName => {
      const nodes = el.getElementsByTagName(tagName);
      for (const node of nodes) {
        node.disabled = true;
        node.classList.add('v-text-field');
      }
    });
    const nodes = el.getElementsByTagName('v-input');
    for (const node of nodes) {
      node.classList.add('v-text-field');
    }
  }
});